import React from "react";
import "./NewsletterSection.css";

// Import required components
import { Heading, Newsletter } from "../../../components";

const NewsletterSection = () => {
  return (
    <section className="newsletter-subscribe">
      <div className="content">
        <Heading title={"Subscribe To Our Newsletter"} linear /> {/* Section heading with linear style */}
        <p>Stay updated on the latest gardening and landscaping tips, plant care advice, and exclusive offers.</p> {/* Subscription description */}
        <Newsletter variant='default' idPrefix='1' /> {/* Newsletter subscription form */}
      </div>
    </section>
  );
};

export default NewsletterSection;